/**
 * Wires external trigger buttons and the CMD+K shortcut to the
 * dedicated <drawer-component id="search-drawer">.
 */
function initSearchDrawer() {
  const searchDrawer = document.querySelector("drawer-component#search-drawer");
  if (!searchDrawer) return;

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-open-search]");
    if (!trigger) return;

    event.preventDefault();
    searchDrawer.open();

    requestAnimationFrame(() => {
      const input = searchDrawer.querySelector("[ref='searchInput']");
      if (input instanceof HTMLElement) input.focus();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.metaKey && event.key === "k") {
      event.preventDefault();

      const dialog = searchDrawer.refs?.dialog;
      if (dialog?.open) {
        searchDrawer.close();
      } else {
        searchDrawer.open();

        requestAnimationFrame(() => {
          const input = searchDrawer.querySelector("[ref='searchInput']");
          if (input instanceof HTMLElement) input.focus();
        });
      }
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSearchDrawer);
} else {
  initSearchDrawer();
}
